import importer from "common/importer";
const { navigate, ROUTES } = importer("NavigationService", null);

export default function* failure({ error }) {
  if (error?.response?.status === 401) {
    yield navigate(ROUTES.SignOut);
  }
}
